// see refusalReasonCode's here https://docs.adyen.com/development-resources/testing/result-code-testing/adyen-response-codes
export const getAdyenRefusalReasonCodeString = (refusalReasonCode) => {
  switch (refusalReasonCode) {
    case '8':
      return 'checkout:COF_PAYMENT_CARD_ERROR_INVALID_CARD_NUMBER'
    case '12':
      return 'checkout:COF_PAYMENT_CARD_ERROR_NOT_ENOUGH_BALANCE'
    case '23':
      return 'checkout:COF_PAYMENT_CARD_ERROR_NOT_PERMITTED'
    case '24':
      return 'checkout:COF_PAYMENT_CARD_ERROR_CVC'
    case '25':
      return 'checkout:COF_PAYMENT_CARD_ERROR_RESTRICTED'
    default:
      return 'checkout:COF_PAYMENT_CARD_ERROR_DEFAULT'
  }
}
